import React, { useEffect, useRef, useState } from "react";
import { FiPhone, FiCalendar, FiPhoneCall } from "react-icons/fi";
import { MdAttachMoney } from "react-icons/md";
import { FaMoneyBillWave, FaWifi } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { subMonths } from "date-fns";

import onlinePay from "../../assets/images/svgs/other/onlinepay.svg";
import cashpay from "../../assets/images/svgs/other/CashPay.svg";
import uploadIcon from "../../assets/images/svgs/other/uploadImg.svg";
import Successicon from "../../assets/images/svgs/other/paydone.svg";

import UploadRow from "../upload/UploadRow";
import InputBase from "../form/inputs/InputBase";
import PrimaryBtn from "../button/PrimaryBtn";
import SecondaryBtn from "../button/SecondaryBtn";
import SuccessSwal from "../Swals/SuccessSwal";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {
  collectPayment,
  getCustomerDataDeliverAnOrder,
} from "../../redux/thunks/orderCustomerThunk";
import { uploadPhoto } from "../../redux/thunks/registerThunks";

const Collectpay = ({
  open,
  onClose,
  orderId,
  onDeliver,
  amountCut,
  customerRawData = null,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const buttonRef = useRef();
  const dateRef = useRef(null);
  const [method, setMethod] = useState("cash");
  const [previewImg, setPreviewImg] = useState(null);
  const [success, setSuccess] = useState(false);
  const [notes, setNotes] = useState("");
  const [mealDetails, setMealDetails] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [price, setPrice] = useState("");
  const [Curr, setCurr] = useState("");
  const [errors, setErrors] = useState({});

  // ✅ Date picker state
  const [startDate, setStartDate] = useState(null);

  // Fetch customer/order details
  useEffect(() => {
    // ✅ If coming from Detail page
    if (customerRawData) {
      setMealDetails({
        customer: {
          customer_id: customerRawData.customer_id,
          customer_name: customerRawData.customer_name,
          customer_contact_no:
            "+" +
            customerRawData.country_code +
            " " +
            customerRawData.contact_no,
        },
        order_amount: customerRawData.amount_due,
        currency_symbol: customerRawData.currency_symbol,
        order_date: new Date().toISOString().split("T")[0],
      });

      setPrice(Math.abs(Number(customerRawData.amount_due)));
      setStartDate(new Date());
    }

    // ✅ Otherwise use old logic (order page)
    else if (orderId) {
      const payload = { order_id: orderId };

      dispatch(getCustomerDataDeliverAnOrder(payload))
        .unwrap()
        .then((res) => {
          // console.log("The collect pay details is :", res.data);
          const getDetails = res.data;
          setMealDetails(getDetails);

          const getCurr = res.data?.currency_symbol;
          setCurr(getCurr);
          if (amountCut !== undefined && amountCut !== null) {
            setPrice(Math.abs(Number(amountCut)).toFixed(2));
          }
          // otherwise fallback
          else if (getDetails.order_amount) {
            setPrice(Math.abs(Number(getDetails.order_amount)).toFixed(2));
          }

          if (getDetails.order_date)
            setStartDate(new Date(getDetails.order_date));
        });
    }
  }, [dispatch, orderId, customerRawData, amountCut]);

  const handleChange = (date) => {
    setStartDate(date);
    setMealDetails((prev) => ({
      ...prev,
      order_date: date.toISOString().split("T")[0],
    }));
  };

  const handlepayupload = (file) => {
    if (!file) return;
    const url = URL.createObjectURL(file);
    setPreviewImg(url);
    setImageFile(file);
  };

  const handleRemoveImage = () => {
    if (previewImg) {
      URL.revokeObjectURL(previewImg);
      setPreviewImg(null);
      setImageFile(null);
    }
  };

  const handleGoBack = () => {
    setSuccess(false);
    navigate("/dashboard");
  };

  const getInitials = (name = "") => {
    const words = name.trim().split(" ").filter(Boolean);

    if (words.length === 0) return "";

    // If only one word → return first 2 letters
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    // If multiple words → first letter of first & second word
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  const validatePaymentFields = () => {
    const newErrors = {};

    // ✅ Amount validation
    if (!price || price.toString().trim() === "") {
      newErrors.price = "Amount is required";
    } else if (isNaN(price)) {
      newErrors.price = "Amount must be a number";
    } else if (Number(price) <= 0) {
      newErrors.price = "Amount must be greater than 0";
    }

    // ✅ Date validation
    if (!startDate) {
      newErrors.startDate = "Date is required";
    } else {
      const today = new Date();
      const twoMonthsAgo = subMonths(today, 2);

      if (startDate > today) {
        newErrors.startDate = "Date cannot be in the future";
      } else if (startDate < twoMonthsAgo) {
        newErrors.startDate = "Date cannot be older than 2 months";
      }
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const handlePaymentClick = async () => {
    if (!validatePaymentFields()) {
      return;
    }
    try {
      let uploadedFileName = null;

      if (imageFile) {
        const formData = new FormData();
        formData.append("type", "payment/payment_proofs");
        formData.append("image", imageFile);

        const uploadRes = await dispatch(uploadPhoto(formData)).unwrap();
        uploadedFileName = uploadRes?.data?.temp_image_name || null;
      }

      const payload = {
        service_provider_customer_id:
          customerRawData?.customer_id || mealDetails?.customer?.customer_id,
        payment_type: method,
        payment_date: mealDetails?.order_date,
        amount: price,
        payment_proof_image: uploadedFileName,
        payment_remark: notes,
      };
      // console.log("the payload is :", payload);
      const res = await dispatch(collectPayment(payload)).unwrap();
      // console.log("The res is :", res.data);
      if (!res?.success) {
        toast.error(res?.message || "Failed to collect payment");
        return;
      }

      // Deliver order
      if (!customerRawData) {
        const delivered = await onDeliver("now");
        if (!delivered) return;
      }
      // toast.success(res.message);
      setSuccess(true);
    } catch (err) {
      toast.error("Payment failed");
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-3 sm:px-4">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal Wrapper */}
      <div
        className="relative w-full max-w-4xl bg-gray-50 rounded-2xl shadow-2xl z-50 
                    max-h-[95vh] flex flex-col overflow-hidden"
      >
        {/* ===== Header (Sticky) ===== */}
        <div className="flex items-center justify-between px-4 sm:px-6 h-14 bg-white border-b sticky top-0 z-20">
          <h1 className="text-base sm:text-lg font-semibold text-gray-900">
            Collect Payment
          </h1>

          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-100 transition"
          >
            ✕
          </button>
        </div>

        {/* ===== Scrollable Content ===== */}
        <div className="flex-1 overflow-y-auto p-4 sm:p-6 space-y-6">
          {/* User Card */}
          <div className="flex items-center gap-4 bg-white p-4 rounded-xl shadow-sm">
            <div className="h-12 w-12 flex items-center justify-center rounded-xl bg-orange-100 text-orange-500 font-semibold">
              {getInitials(mealDetails?.customer?.customer_name)}
            </div>
            <div className="min-w-0">
              <p className="font-medium text-gray-900 truncate">
                {mealDetails?.customer?.customer_name}
              </p>
              <p className="flex items-center gap-1 text-sm text-gray-500 truncate">
                <FiPhoneCall /> {mealDetails?.customer?.customer_contact_no}
              </p>
            </div>
          </div>

          {/* Due Amount */}
          <p className="text-center text-orange-500 font-semibold text-sm sm:text-base">
            Due Amount : {Curr || mealDetails?.currency_symbol}{" "}
            {Math.abs(
              Number(
                amountCut !== undefined && amountCut !== null
                  ? amountCut
                  : mealDetails?.order_amount,
              ),
            ).toFixed(2)}
          </p>

          {/* Amount & Date */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Amount */}
            <div>
              <label className="text-sm text-gray-600">
                Amount <span className="text-red-500 ml-1">*</span>
              </label>
              <div className="mt-1 flex items-stretch rounded-xl border bg-white overflow-hidden">
                <span className="flex items-center px-3 text-orange-500 bg-orange-50 text-sm">
                  {Curr || mealDetails?.currency_symbol}
                </span>
                <input
                  type="number"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  onBlur={() => setPrice(Number(price).toFixed(2))}
                  placeholder="Enter Amount"
                  className="w-full px-3 py-3 outline-none text-sm"
                />
              </div>
              {errors.price && (
                <p className="text-xs text-red-500 mt-1">{errors.price}</p>
              )}
            </div>

            {/* Date */}
            <div>
              <label className="text-sm text-gray-600">
                Date <span className="text-red-500 ml-1">*</span>
              </label>
              <div className="mt-1 relative group">
                <div
                  className="flex justify-between items-center rounded-xl border border-gray-200 bg-white px-3
    shadow-sm transition-all duration-200
    hover:border-[#FF6943]/60 hover:shadow-md
    focus-within:border-[#FF6943] focus-within:ring-2 focus-within:ring-[#FF6943]/20"
                >
                  <DatePicker
                    ref={dateRef}
                    selected={startDate}
                    onChange={handleChange}
                    maxDate={new Date()}
                    minDate={subMonths(new Date(), 2)}
                    placeholderText="Select date"
                    className="w-full py-3 text-sm text-[#191919] bg-transparent outline-none placeholder:text-gray-400"
                    dateFormat="yyyy-MM-dd"
                  />

                  <FiCalendar
                    size={18}
                    className="text-gray-400 ml-2 cursor-pointer transition-colors duration-200 
      group-focus-within:text-[#FF6943]"
                    onClick={() => dateRef.current.setOpen(true)}
                  />
                </div>
              </div>
              {errors.startDate && (
                <p className="text-xs text-red-500 mt-1">{errors.startDate}</p>
              )}
            </div>
          </div>

          {/* Payment Method */}
          <div>
            <label className="block mb-2 text-sm text-gray-600">
              Payment Method
            </label>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <button
                onClick={() => setMethod("cash")}
                className={`flex items-center gap-2 px-4 py-3 rounded-xl border justify-center text-sm ${
                  method === "cash"
                    ? "border-orange-500 bg-orange-50"
                    : "bg-white text-gray-600"
                }`}
              >
                <img src={cashpay} alt="cashpay" className="w-5 h-5" />
                Cash
              </button>

              <button
                onClick={() => setMethod("online")}
                className={`flex items-center gap-2 px-4 py-3 rounded-xl border justify-center text-sm ${
                  method === "online"
                    ? "border-orange-500 bg-orange-50"
                    : "bg-white text-gray-600"
                }`}
              >
                <img src={onlinePay} alt="onlinePay" className="h-5 w-5" />
                Online
              </button>
            </div>
          </div>

          {/* Upload & Remarks */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h2 className="text-sm sm:text-base font-semibold text-gray-900">
                Upload Payment Proof
              </h2>

              <div className="w-full mt-2">
                <UploadRow
                  id="payment-proof-upload"
                  icon={uploadIcon}
                  onChange={(e) => handlepayupload(e.target.files[0])}
                />
              </div>

              {previewImg && (
                <div className="mt-4 relative w-24 h-28">
                  <img
                    src={previewImg}
                    alt="Payment Proof"
                    className="w-full h-full object-cover border border-gray-200 rounded-xl"
                  />
                  <button
                    onClick={handleRemoveImage}
                    className="absolute -top-2 -right-2 bg-black/70 text-white rounded-full w-6 h-6 flex items-center justify-center"
                  >
                    ✕
                  </button>
                </div>
              )}
            </div>

            <div>
              <InputBase
                label="Remarks"
                name="notes"
                type="textarea"
                placeholder="Remarks"
                rows={3}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="flex flex-col justify-center items-center sm:flex-row gap-3 pt-4">
            <PrimaryBtn
              btnName="Collect Payment"
              clickEvent={handlePaymentClick}
            />

            <SecondaryBtn btnName="Cancel" clickEvent={onClose} />
          </div>
        </div>

        {/* SuccessSwal remains same */}
        <SuccessSwal
          open={success}
          icon={
            <img
              src={Successicon}
              alt="success"
              className="h-16 w-16 mx-auto"
            />
          }
          title="Payment Received!"
          description="Payment details have been added successfully."
          onConfirm={handleGoBack}
          onClose={() => {
            setSuccess(false);
            navigate("/dashboard");
          }}
        />
      </div>
    </div>
  );
};

export default Collectpay;
